import enBannerJson from "@/public/locales/en/banner.json";
import enCommonJson from "@/public/locales/en/common.json";
import enEditorJson from "@/public/locales/en/editor.json";
import enGnbJson from "@/public/locales/en/gnb.json";
import enLnbJson from "@/public/locales/en/lnb.json";
import enPopupJson from "@/public/locales/en/popup.json";

import koBannerJson from "@/public/locales/ko/banner.json";
import koCommonJson from "@/public/locales/ko/common.json";
import koEditorJson from "@/public/locales/ko/editor.json";
import koGnbJson from "@/public/locales/ko/gnb.json";
import koLnbJson from "@/public/locales/ko/lnb.json";
import koPopupJson from "@/public/locales/ko/popup.json";

import i18n from "i18next";
import { NextRouter } from "next/router";
import { initReactI18next } from "react-i18next";

export const langueges = [
  { label: "ENGLISH", value: "en" },
  { label: "KOREAN", value: "ko" },
];

export const getLanguage = (locale?: string) => {
  const lang = langueges.find((language) => language.value === locale);

  return lang ? lang.label : "KOREAN";
};

export const setLanguage = (locale: string, router: NextRouter) => {
  const { pathname, query, asPath } = router;
  document.cookie = `NEXT_LOCALE=${locale}; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT`;
  router.push({ pathname, query }, asPath, {
    locale,
  });
};

i18n.use(initReactI18next).init({
  defaultNS: "common",
  resources: {
    en: {
      ...enCommonJson,
      ...enGnbJson,
      ...enPopupJson,
      ...enLnbJson,
      ...enEditorJson,
      ...enBannerJson,
    },
    ko: {
      ...koCommonJson,
      ...koGnbJson,
      ...koPopupJson,
      ...koLnbJson,
      ...koEditorJson,
      ...koBannerJson,
    },
  },
  lng: "ko",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
